import React, { HTMLAttributes, ReactElement } from 'react';
import Container from '../../foundational/Layout/Container';
import { IImageProps } from '../../atoms/Image/Image';
import './ImageList.css';
import Row from '../../foundational/Layout/Row';
import Image from '../../atoms/Image';

interface IImageListItem extends IImageProps{
    imagecaption?: string;
}

export interface IImageListProps extends HTMLAttributes<any> {
    className?: string;
    containerClass?: string;
    bgColor?: 'light-grey' | 'blue-denim' | 'white';
    justify?: 'center' | 'left' | 'right';
    imageListItems: IImageListItem[];
    containerFluid?: boolean;
    imageBlockClass?: string;
    nowrap?: boolean;
}

const ImageList = ({
    className = '',
    containerClass = '',
    bgColor,
    justify,
    imageListItems = [],
    containerFluid = false,
    imageBlockClass,
    nowrap = false,
    ...rest
}: IImageListProps): JSX.Element => {

    return (
        <div className={`ImageList ${className}`}>
            <Container fluid={containerFluid}
                className={`ImageList__container ${containerClass} ${bgColor ? `bg__${bgColor}` : ''}`} {...rest}>
                <Row className={`ImageList__imageRow${justify ? `--${justify}` : ''} ${nowrap ? 'flex flex-nowrap': ''}`}>
                    {imageListItems.length > 0 && imageListItems.map((imageItem, index) => {
                        return (
                            <div className={`ImageList__imageCol ${imageBlockClass || ''}`} key={index}>
                                <div className='ImageList__itemContainer'>
                                    <Image {...imageItem}/>
                                    {imageItem.imagecaption && <p>{imageItem.imagecaption}</p>}
                                </div>
                            </div>
                        );
                    })}
                </Row>
            </Container>
        </div>
    );
};

export default ImageList;
